import type { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { ApiError, useMe } from "@/api";
import { ErrorBanner } from "@/components/ErrorBanner";
import { Spinner } from "@/ui";

/** Renders children only with a valid session; otherwise redirects to /login?next=… */
export function RequireAuth({ children }: { children: ReactNode }) {
  const me = useMe();
  const location = useLocation();

  if (me.isLoading) {
    return (
      <div className="login">
        <Spinner label="Checking session" />
      </div>
    );
  }
  const unauthorized =
    me.data === null || (me.error instanceof ApiError && me.error.isUnauthorized);
  if (unauthorized) {
    const next = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/login?next=${next}`} replace />;
  }
  // C2: a not-yet-enrolled admin gets a limited session until TOTP is enabled.
  if (me.data?.totp_setup_required) {
    return <Navigate to="/login" replace />;
  }
  if (me.error) {
    return (
      <div className="login">
        <ErrorBanner error={me.error} onRetry={() => me.refetch()} title="Cannot reach the API" />
      </div>
    );
  }
  return <>{children}</>;
}
